import { Component, inject, OnInit, WritableSignal, signal } from '@angular/core';
import { AssignmentProjectLoadunitsComponent } from '../assignment-project-loadunits/assignment-project-loadunits.component';
import { ActivatedRoute } from '@angular/router';
import { ContextService } from '../../services/context.service';
import {
  AssignmentType,
  AssignmentDto,
  AssignmentLoadunitDto,
  AssignmentSubtableDataDto,
} from '../../shared/generated/backend';
import { DxMultiViewModule, DxTabsModule, DxButtonModule } from 'devextreme-angular';
import { AssignmentDocumentsComponent } from '../assignment-documents/assignment-documents.component';
import { AssignmentMemosComponent } from '../assignment-memos/assignment-memos.component';
import { AssignmentPositionsComponent } from '../assignment-positions/assignment-positions.component';
import { AssignmentService } from '../../shared/generated/backend';
import { firstValueFrom } from 'rxjs';
import { AssignmentDetailComponent } from '../assignment-detail/assignment-detail.component';
import { AssignmentCrateComponent } from '../assignment-crate/assignment-crate.component';
import { AssignmentStockComponent } from '../assignment-stock/assignment-stock.component';
import { AssignmentAddressComponent } from '../assignment-address/assignment-address.component';

import { TranslateModule } from '@ngx-translate/core';

export type AssignmentExtendedDto = AssignmentDto & { subtableData?: AssignmentSubtableDataDto };
@Component({
  selector: 'app-assignment-context-view',
  imports: [
    AssignmentProjectLoadunitsComponent,
    DxTabsModule,
    DxMultiViewModule,
    AssignmentMemosComponent,
    AssignmentPositionsComponent,
    AssignmentDocumentsComponent,
    AssignmentDetailComponent,
    AssignmentCrateComponent,
    AssignmentStockComponent,
    AssignmentAddressComponent,
    TranslateModule,
    DxButtonModule,
  ],
  templateUrl: './assignment-context-view.component.html',
  styleUrls: ['./assignment-context-view.component.scss'],
})
export class AssignmentContextViewComponent implements OnInit {
  readonly assignmentId = signal<number>(0);

  readonly type = signal<AssignmentType>('Unknown' as AssignmentType);

  data: WritableSignal<AssignmentExtendedDto | undefined> = signal(undefined);
  subtableData: WritableSignal<AssignmentSubtableDataDto | undefined> = signal(undefined);
  loadunits: WritableSignal<AssignmentLoadunitDto[] | undefined> = signal(undefined);
  readonly isLoading: WritableSignal<boolean> = signal(false);

  readonly tabs = [
    {
      text: 'ASSIGNMENTDETAILS.DTO.LOADUNITS',
      type: 'project-loadunits',
    },
    {
      text: 'ASSIGNMENTDETAILS.DTO.MEMOS',
      type: 'memos',
    },
    {
      text: 'ASSIGNMENTDETAILS.DTO.DOCS',
      type: 'documents',
    },
    {
      text: 'ASSIGNMENTDETAILS.DTO.POSITIONS',
      type: 'positions',
    },
    {
      text: 'ASSIGNMENTDETAILS.DTO.CRATES',
      type: 'crates',
    },
    {
      text: 'ASSIGNMENTDETAILS.DTO.STOCK',
      type: 'stock',
    },
    {
      text: 'ASSIGNMENTDETAILS.DTO.ADDRESS',
      type: 'address',
    },
  ];

  private contextService = inject(ContextService);
  private activatedRoute = inject(ActivatedRoute);
  private assignmentService = inject(AssignmentService);

  ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      this.assignmentId.set(+params['assignmentId']);
      this.type.set(params['type'] as AssignmentType);

      // Set selectedData based on assignmentId and type
      this.loadSelectedData();
    });
  }

  async loadSelectedData() {
    this.isLoading.set(true);
    try {
      const dto = await firstValueFrom(this.assignmentService.getAssignment(this.assignmentId(), this.type(), false));
      this.data.set(dto.assignment);
      this.subtableData.set(dto.subtableData);
      this.loadunits.set(dto.loadunits);
    } catch (error) {
      console.error('Error fetching assignment data', error);
      this.loadunits.set(undefined);
    } finally {
      this.isLoading.set(false);
    }
  }

  closeAll() {
    this.contextService.closeAllContextViews();
  }
}
